import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Screens/Login";
import Home from "./Screens/Home";
import SearchEmail from "./Screens/SearchEmail";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/searchEmail" element={<SearchEmail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
